import { ApiDimension, ApiOperator } from "@incendium/api";
import { AttributionExplorer, ExplorerProvider } from "features/explorer";
import { TExploreConfig } from "features/explorer/types";
import { useMemo } from "react";

export type AttributionPerformanceExplorers =
  | "Paid Traffic Sources"
  | "Non-Paid Traffic Sources"
  | "All Traffic Sources"
  | "Paid Landing Pages"
  | "Non-Paid Landing Pages"
  | "All Landing Pages";

function AttributionExplorerPage() {

  const config: TExploreConfig<AttributionPerformanceExplorers> =
    useMemo(() => {
      const settings = {
        ranking: [],
      }

      const traffic = {
        analyseBy: {
          description: "",
          grouping: [
            {
              option: "",
              dimensions: [
                ApiDimension.DIMENSION_CHANNEL,
                ApiDimension.DIMENSION_SOURCE,
                ApiDimension.DIMENSION_MEDIUM,
                ApiDimension.DIMENSION_CAMPAIGN,
                ApiDimension.DIMENSION_TERM,
              ],
            },
          ],
        },
        ...settings
      }

      const landing = {
        analyseBy: {
          description: "",
          grouping: [
            {
              option: "",
              dimensions: [
                ApiDimension.DIMENSION_LANDING_PAGE_LOCATION,
                ApiDimension.DIMENSION_LANDING_PAGE_PATH,
                ApiDimension.DIMENSION_LANDING_PAGE_TYPE,
                ApiDimension.DIMENSION_LANDING_NEXT_PAGE_LOCATION,
                ApiDimension.DIMENSION_LANDING_NEXT_PAGE_PATH,
                ApiDimension.DIMENSION_LANDING_NEXT_PAGE_TYPE,
              ],
            },
          ],
        },
        ...settings
      }

      return {
        "Paid Traffic Sources": {
          title: "Paid Traffic Sources",
          desc: "Dig deeper into attribution from paid traffic sources, compare models and measure the value of all multiple touchpoints in the path to purchase.",
          ...traffic,
          attributes: [{
            key: ApiDimension.DIMENSION_TRAFFIC_TYPE,
            operator: ApiOperator.EQUAL,
            value: "Paid"
          }]
        },
        "Non-Paid Traffic Sources": {
          title: "Non-Paid Traffic Sources",
          desc: "Dig deeper into attribution from non-paid traffic sources, compare models and measure the value of all multiple touchpoints in the path to purchase.",
          ...traffic,
          attributes: [{
            key: ApiDimension.DIMENSION_TRAFFIC_TYPE,
            operator: ApiOperator.EQUAL,
            value: "Non-Paid"
          }]
        },
        "All Traffic Sources": {
          title: "All Traffic Sources",
          desc: "Dig deeper into attribution from all traffic sources, compare models and measure the value of all multiple touchpoints in the path to purchase.",
          ...traffic
        },
        "Paid Landing Pages": {
          title: "Paid Landing Pages",
          desc: "Dig deeper into attribution from paid landing pages, compare models and measure the value of all multiple touchpoints in the path to purchase.",
          ...landing,
          attributes: [{
            key: ApiDimension.DIMENSION_TRAFFIC_TYPE,
            operator: ApiOperator.EQUAL,
            value: "Paid"
          }]
        },
        "Non-Paid Landing Pages": {
          title: "Non-Paid Landing Pages",
          desc: "Dig deeper into attribution from non-paid landing pages, compare models and measure the value of all multiple touchpoints in the path to purchase.",
          ...landing,
          attributes: [{
            key: ApiDimension.DIMENSION_TRAFFIC_TYPE,
            operator: ApiOperator.EQUAL,
            value: "Non-Paid"
          }]
        },
        "All Landing Pages": {
          title: "All Landing Pages",
          desc: "Dig deeper into attribution from all landing pages, compare models and measure the value of all multiple touchpoints in the path to purchase.",
          ...landing
        }
      }
    }, [])


  return <ExplorerProvider configs={config} type={"Paid Traffic Sources"}>
    <AttributionExplorer />
  </ExplorerProvider>
}

export default AttributionExplorerPage;